import { useQuery } from "@tanstack/react-query";

import emojiPickerApi from "../api";
import { QUERY_KEYS } from "../constants";

export const useEmojiData = () =>
  useQuery({
    queryKey: [QUERY_KEYS.EMOJI_DATA],
    queryFn: emojiPickerApi.fetch,
  });
